import { render, staticRenderFns } from "./buyKecelakaanDiri.vue?vue&type=template&id=3803225c&"
import script from "./buyKecelakaanDiri.vue?vue&type=script&lang=ts&"
export * from "./buyKecelakaanDiri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports